import { useEffect, useState } from 'react';
import Image from '../../Assets/Images/Donation.webp'
import { getComponent } from '../../ComponentsMap';
import { createDonationCardInstance } from '../../Models/DonationCard';
import { refreshAosLite } from '../../Services/Animations/aosLite';
const Campaigns = (props) => {
    const [campaigns,setCampaigns] = useState([]);
    const campaign = {
        type:"NormalDonationCard",
        title:"Monthly Fixed Activities",
        data: [
            {
                id: 1,
                title: "Medical Emergency",
                description: "315 cases in 19 provinces received their monthly allowances with cards",
                image: Image,
                compName: "NormalDonationCard"
            },
            {
                id: 2,
                title: "Food Emergency",
                description: "315 cases in 19 provinces received their monthly allowances with cards",
                image: Image,
                compName: "NormalDonationCard"
            },
            {
                id: 3,
                title: "Shelter Emergency",
                description: "315 cases in 19 provinces received their monthly allowances with cards",
                image: Image,
                compName: "NormalDonationCard"
            },
            {
                id: 4,
                title: "Education Emergency",
                description: "315 cases in 19 provinces received their monthly allowances with cards",
                image: Image,
                compName: "NormalDonationCard"
            },
        ]

    }
    const campaings2={
        title:"Goodwill Campaigns",
        data:[
            {
                id: 1,
                title: 'Goodwill Campaigns',
                description: 'In February, we worked to provide assistance to…',
                image: Image,
                current: 70,
                target: 150,
                className: 'ProgressCard',
                compName: 'ProgressingDonationCard',
                style: [
                    { "background-color": "#eee" },
                    { "color": "black" },
                ]
            },
            {
                id: 2,
                title: 'Goodwill Campaigns',
                description: 'In February, we worked to provide assistance to…',
                image: Image,
                current: 70,
                target: 150,
                className: 'ProgressCard',
                compName: 'ProgressingDonationCard',
                style: [
                    { "background-color": "#eee" },
                    { "color": "black" },
                ]
            },
            {
                id: 3,
                title: 'Goodwill Campaigns',
                description: 'In February, we worked to provide assistance to…',
                image: Image,
                current: 70,
                target: 150,
                className: 'ProgressCard',
                compName: 'ProgressingDonationCard',
                style: [
                    { "background-color": "#eee" },
                    { "color": "black" },
                ]
            },
        ]
    }
    const [donationCardInstance, setDonationCardInstance] = useState(createDonationCardInstance());
    const [currentData, setCurrentData] = useState(donationCardInstance.getData());
    const [NormalDisplay, setNormalDisplay] = useState('normal');
    const [ProgressingDisplay, setProgressingDisplay] = useState('normal');
    const [normalAnimation, setNormalAnimation] = useState(null);
    const [progressingAnimation, setProgressingAnimation] = useState(null);
        useEffect(() => {
            getData();
        }, []);
    
        const getData = async () => {
            try {
                await donationCardInstance.load();
                setCurrentData(donationCardInstance.getData());
                donationCardInstance.renderStyles();
                setNormalDisplay(donationCardInstance.getNormalCardDisplay());
                setProgressingDisplay(donationCardInstance.getProgressingCardDisplay());
                setNormalAnimation(donationCardInstance.getNormalAnimation());
                setProgressingAnimation(donationCardInstance.getProgressingAnimation());
            } catch (error) {
                console.error(error);
            }
        };

    useEffect(()=>{
        if(props?.CampaignType==='Normal')
            setCampaigns(campaign);
        else if(props?.CampaignType==='Progressing')
            setCampaigns(campaings2)
    },[]);

    useEffect(() => {
        // Ensure AOS picks up new cards & animation props on first render
        if (props?.campaigns?.length || campaigns?.data?.length) {
            setTimeout(() => {
                try { refreshAosLite(); } catch (e) {}
            }, 50);
        }
    }, [props?.campaigns, campaigns, normalAnimation, progressingAnimation]);

    return (
        <div className="container">
            <div className="Center mb-3">
                <h1>{props?.section?.name}</h1>
            </div>
            <div className="row">
                {console.log("props?.campaigns" , props?.campaigns)}
                {props?.campaigns?.map((row) => {
                    const newRow = { ...row, display: row.campaignSection.mode === 'Normal' ? NormalDisplay: ProgressingDisplay };
                    if (row.campaignSection.mode === 'Normal') {
                        return getComponent('NormalDonationCard', { ...newRow, animation: normalAnimation });
                    } else {
                        return getComponent('ProgressingDonationCard', { ...newRow, animation: progressingAnimation });
                    }
                   
                })}
            </div>
        </div>
    );
}
export default Campaigns;